import Parse from "parse";

// Initialize Parse
const parseInitialize = async () => {
  const appId = process.env.REACT_APP_PARSE_APPLICATION_ID;
  const jsKey = process.env.REACT_APP_PARSE_JAVASCRIPT_KEY;
  const serverURL = process.env.REACT_APP_PARSE_SERVER_URL;

  if (!appId || !jsKey || !serverURL) {
    console.error("ParseClient initialization failed: Missing environment variables.");
    return;
  }

  Parse.initialize(appId, jsKey);
  Parse.serverURL = `${serverURL}/parse`;

  // Attach the login JWT as `Authorization: Bearer` on every Parse request.
  // Parse 4.2.0's RESTController merges CoreManager REQUEST_HEADERS into every
  // request, so this one line covers all Parse.Cloud.run / Parse.Query calls
  // (the backend withAuth reads this header). `authJwt` is the RS256 JWT from
  // login, distinct from `sessionToken` (the _Session token used by
  // /legacy-auth validate/logout/dfns routes).
  const authJwt = localStorage.getItem("authJwt");
  Parse.CoreManager.set("REQUEST_HEADERS", authJwt ? { Authorization: `Bearer ${authJwt}` } : {});

  // Hydrate Parse.User.current() from the _Session token (used by flows that
  // read the current user). Auth for cloud calls rides on the JWT header above.
  const sessionToken = localStorage.getItem("sessionToken");
  if (sessionToken) {
    try {
      await Parse.User.become(sessionToken);
    } catch (error) {
      console.error("Error becoming user with sessionToken:", error);
    }
  }
};

export default parseInitialize;
